/**
 * @author Fernando Ruano
 * @file constants.js
 * @description MedicalParameter Constants
 */

// Generic actions
export const GET_ALL_MEDICAL_PARAMETERS =
  'MedicalParameters/GET_ALL_MEDICAL_PARAMETERS';
export const GET_MEDICAL_PARAMETER_BY_ID =
  'MedicalParameters/GET_MEDICAL_PARAMETER_BY_ID';
export const CREATE_MEDICAL_PARAMETER =
  'MedicalParameters/CREATE_MEDICAL_PARAMETER';
export const UPDATE_MEDICAL_PARAMETER =
  'MedicalParameters/UPDATE_MEDICAL_PARAMETER';
export const DELETE_MEDICAL_PARAMETER_BY_ID =
  'MedicalParameters/DELETE_MEDICAL_PARAMETER_BY_ID';
